import cx from "classnames";
import React from "react";
import { FormErrors } from "redux-form";

import { Btn, BtnType } from "@/mk2/components/Btn";
import { Form } from "@/mk2/components/Form";
import { SubmitButton } from "@/mk2/components/forms/SubmitButton";
import { TextareaField } from "@/mk2/components/forms/TextareaField";
import { UploadedPhoto } from "@/mk2/containers/PhotosUpload/PhotosUpload";
import { ComposeToolbar, FIXED } from "@/mk2/containers/Toolbar/Toolbar";
import { MKReduxFormInjectedProps, mkReduxForm } from "@/mk2/decorators/mkReduxForm";
import {
    BZ2_REVIEW_REPLY,
    CANCEL,
    FORMS_DEFAULT_REQUIRED_FIELD_ERROR,
    YOUR_REPLY,
} from "@/mk/autogenerated/translations/ReviewReplyForm.bd7b4c15b46ea25c9069a190a65638db";

import styles from "./ReviewReplyForm.mscss";

export interface ReplyFormData {
    message: string;
    photos: UploadedPhoto[];
}

const emojisConfig = {
    fields: ["message"],
    defaultField: "message",
};

const photosConfig = {
    photoType: "review",
    multiple: false,
    previewPhotoSize: "s150x150",
    showPhotoCode: false,
};

interface OwnProps {
    className?: string;
    form: string;
    initialValues: ReplyFormData;

    onSave(values: ReplyFormData);
    onCancel(event: React.MouseEvent<HTMLAnchorElement>);
}

type Props = OwnProps;

class ReviewReplyForm extends React.Component<
    Props & MKReduxFormInjectedProps<ReplyFormData, Props>
> {
    public render() {
        const { className, handleSubmit, form, onCancel } = this.props;

        return (
            <Form className={cx(styles.ReviewReplyForm, className)} onSubmit={handleSubmit}>
                <div className={styles.ReviewReplyForm__message}>
                    <TextareaField
                        name="message"
                        rows={3}
                        maxRows={5}
                        placeholder={YOUR_REPLY}
                        bottomBorder={false}
                        isCompact
                    />
                </div>

                <ComposeToolbar
                    className={styles.ReviewReplyForm__toolbar}
                    formName={form}
                    emojis={emojisConfig}
                    photos={photosConfig}
                    stickers={false}
                    isFixed={FIXED.NEVER}
                    isInBlogs
                    rightAction={
                        <div className={styles.ReviewReplyForm__actionButtons}>
                            <Btn
                                className={styles.ReviewReplyForm__cancel}
                                type={BtnType.Link}
                                label={CANCEL}
                                onClick={onCancel}
                            />
                            <SubmitButton
                                className={styles.ReviewReplyForm__submit}
                                label={BZ2_REVIEW_REPLY}
                                formName={form}
                                btnType={BtnType.Blue}
                            />
                        </div>
                    }
                />
            </Form>
        );
    }
}

function validate(values: ReplyFormData): FormErrors<ReplyFormData> {
    const errors: FormErrors<ReplyFormData> = {};
    if (!values.message) {
        errors.message = FORMS_DEFAULT_REQUIRED_FIELD_ERROR;
    }

    return errors;
}

export default mkReduxForm<ReplyFormData, Props>({
    photosConfig,
    onValidate: validate,
    onSave: (values, props) => props.onSave(values),
})(ReviewReplyForm);
